/* eslint-disable import/export */
/* eslint-disable import/no-internal-modules */
export * from "loaders/index";
export * from "./legacy-glTF";
export * from "./legacy-glTF1";
export * from "./legacy-glTF2";
export * from "./legacy-objFileLoader";
export * from "./legacy-stlFileLoader";
